import React, { useEffect, useRef, useState } from 'react';
import { HashRouter  as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Cart from './components/Cart';
import ContactPage from './components/ContactPage';
import ContactMenu from './components/ContactMenu';
import FacebookChat from './components/FacebookChat';

const CART_STORAGE_KEY = 'yen-sao-tam-an-cart';
const CART_TTL_MS = 24 * 60 * 60 * 1000;

const loadStoredCart = () => {
  if (typeof window === 'undefined') return [];

  try {
    const savedCart = window.localStorage.getItem(CART_STORAGE_KEY);
    if (!savedCart) return [];

    const parsedCart = JSON.parse(savedCart);
    if (!Array.isArray(parsedCart.items) || parsedCart.expiresAt <= Date.now()) {
      window.localStorage.removeItem(CART_STORAGE_KEY);
      return [];
    }

    return parsedCart.items;
  } catch (error) {
    window.localStorage.removeItem(CART_STORAGE_KEY);
    return [];
  }
};

const App = () => {
  const [cart, setCart] = useState(loadStoredCart);
  const isInitialCartLoad = useRef(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (isInitialCartLoad.current) {
      isInitialCartLoad.current = false;
      return;
    }

    if (cart.length === 0) {
      window.localStorage.removeItem(CART_STORAGE_KEY);
      return;
    }

    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify({
        items: cart,
        expiresAt: Date.now() + CART_TTL_MS,
      })
    );
  }, [cart]);

  const addToCart = (product) => {
    setCart(prevCart => {
      const existingProduct = prevCart.find(item => item.id === product.id);
      if (existingProduct) {
        return prevCart.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
    alert(`${product.name} đã được thêm vào giỏ hàng!`);
  };

  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
    } else {
      setCart(prevCart =>
        prevCart.map(item =>
          item.id === productId ? { ...item, quantity: newQuantity } : item
        )
      );
    }
  };

  const handleCheckout = () => {
    if (cart.length === 0) {
      alert("Giỏ hàng của bạn đang trống!");
      return;
    }
    // In a real app, you would redirect to a checkout page or open a payment modal.
    alert("Thanh toán thành công! Cảm ơn bạn đã mua hàng.");
    setCart([]); // Clear cart after checkout
  };

  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <Router>
      <div className="font-sans text-gray-700 bg-white">
        <Header cartCount={cartCount} />
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route
            path="/cart"
            element={
              <Cart
                cart={cart}
                updateQuantity={updateQuantity}
                removeFromCart={removeFromCart}
                handleCheckout={handleCheckout}
              />
            }
          />
        </Routes>
        <Footer />
        <FacebookChat />
        <ContactMenu />
      </div>
    </Router>
  );
};

export default App;
